import options from "../../options";

const BUILD_MARKER_KEY = "nekohr_hr_build_marker";
const BUILD_RELOAD_GUARD_KEY = "nekohr_hr_build_reload_guard";
/** Bump when cache-bust logic changes so all clients re-check once. */
const ASSET_GENERATION = "3";

/**
 * Reset caches when deploy changes. SW is off; this catches disk cache + old tabs.
 * Does not clear localStorage (Koneko access overrides, dashboard panel prefs, JWT).
 */
export async function ensureFreshHrAssets() {
  if (typeof window === "undefined") return;

  if ("serviceWorker" in navigator) {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    } catch {
      // ignore
    }
  }

  const commit = String(options.commitHash || "");
  const marker = `${ASSET_GENERATION}:${String(
    options.buildType || ""
  )}${commit}`;
  const previous = localStorage.getItem(BUILD_MARKER_KEY);

  const base = process.env.BASE_URL || "/";
  let serverAppId = "";
  try {
    const res = await fetch(`${base}index.html?_=${Date.now()}`, {
      cache: "no-store",
    });
    if (res.ok) {
      const html = await res.text();
      const match = html.match(/\/js\/app\.([a-f0-9]+)\.js/);
      if (match) serverAppId = match[1];
    }
  } catch {
    // Offline — continue with marker-only checks.
  }

  const currentScript = [...document.getElementsByTagName("script")]
    .map((el) => el.src || "")
    .find((src) => /\/js\/app\.[a-f0-9]+\.js/.test(src));
  const scriptAppId =
    currentScript && currentScript.match(/\/app\.([a-f0-9]+)\.js/)
      ? currentScript.match(/\/app\.([a-f0-9]+)\.js/)[1]
      : "";

  const markerNeedsReload = Boolean(previous && previous !== marker);
  const scriptStale =
    Boolean(serverAppId) && Boolean(scriptAppId) && scriptAppId !== serverAppId;
  const scriptMissingButServerHas =
    Boolean(serverAppId) && !scriptAppId && !currentScript;

  if (markerNeedsReload || scriptStale || scriptMissingButServerHas) {
    localStorage.setItem(BUILD_MARKER_KEY, marker);
    const guardKey = `${BUILD_RELOAD_GUARD_KEY}:${marker}:${
      serverAppId || "na"
    }`;
    if (!sessionStorage.getItem(guardKey)) {
      console.warn(
        `[nekohr] Fresh assets required (marker ${
          previous || "none"
        } → ${marker}` +
          (serverAppId ? `, app.${serverAppId}.js` : "") +
          "). Clearing caches…"
      );
      sessionStorage.setItem(guardKey, "1");
      try {
        if ("serviceWorker" in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations();
          await Promise.all(regs.map((r) => r.unregister()));
        }
        if (typeof caches !== "undefined") {
          const keys = await caches.keys();
          await Promise.all(keys.map((k) => caches.delete(k)));
        }
      } catch {
        // ignore
      }
      const keepHash = window.location.hash || "#/";
      window.location.replace(
        `${window.location.pathname}${window.location.search}${keepHash}`
      );
      window.location.reload();
      return;
    }
  }

  if (!previous) {
    localStorage.setItem(BUILD_MARKER_KEY, marker);
  }

  if (
    serverAppId &&
    scriptAppId &&
    scriptAppId === serverAppId &&
    previous === marker
  ) {
    sessionStorage.removeItem(
      `${BUILD_RELOAD_GUARD_KEY}:${marker}:${serverAppId}`
    );
  }
}
